import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { useSuiteHeaderTheme } from '@ms/yammer-hooks/dist/suiteHeaderTheme';
import type { ITheme } from '@ms/yammer-web-core-ui/dist/util/theme';
import { createCustomizedThemeWithSlotOverrides } from '@ms/yammer-web-core-ui/dist/util/theme';
import { useMemo } from 'react';

const getName = (id?: string, type?: string) => {
  const nameParts = ['yammerWeb'];
  if (id) {
    nameParts.push(`id:${id}`);
  }

  if (type) {
    nameParts.push(`type:${type}`);
  }

  return nameParts.join('-');
};

type UseThemeWithSuiteHeaderOverrides = () => ITheme;
export const useThemeWithSuiteHeaderOverrides: UseThemeWithSuiteHeaderOverrides = () => {
  const suiteHeaderTheme = useSuiteHeaderTheme();
  const isUserThemesDeprecated = useExperimentTreatmentWithoutReporting('UserThemesDeprecation') === true;

  const effectiveTheme = useMemo(
    () =>
      isUserThemesDeprecated
        ? {
            ...suiteHeaderTheme,
            isDefault: true,
            colors: undefined,
            id: undefined,
            type: 'App',
          }
        : suiteHeaderTheme,
    [isUserThemesDeprecated, suiteHeaderTheme]
  );

  return useMemo(
    () =>
      createCustomizedThemeWithSlotOverrides({
        name: isUserThemesDeprecated ? 'yammerWeb-default' : getName(effectiveTheme.id, effectiveTheme.type),
        theme: { isInverted: effectiveTheme.isInverted },
        paletteOverrides: effectiveTheme.colors,
      }),
    [isUserThemesDeprecated, effectiveTheme]
  );
};
